var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('error-disp',{model:{value:(_vm.error),callback:function ($$v) {_vm.error=$$v},expression:"error"}}),_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('v-col',{attrs:{"cols":"12","md":"11","lg":"9"}},[_c('v-card',{staticClass:"elevation-4"},[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(" "+_vm._s(_vm.formatD(_vm.reportDate))+" ")]),_c('v-card-text',{staticClass:"text-body-1"},[_c('chart-card',{attrs:{"data":_vm.chartYearlySalesDollar,"layout":{
                  yaxis: { tickformat:',.3r', title: '$ (000s)' },
                  xaxis: { tickformat:'.0f', dtick: 1 },
                  height: 240,
                  font: {size: 11},
                  margin: {t: 50, b:30, r: 200},
                  bargap :0.15, barmode: 'stack'},"caption":"Total annual sales value","download-title":"Annual_sales_value"}}),_c('chart-card',{attrs:{"data":_vm.chartYearlyBurialsGroups,"layout":{
                  yaxis: { tickformat:',.0f' },
                  xaxis: { tickformat:'.0f', dtick: 1 },
                  height: 300,
                  font: {size: 11},
                  margin: {t: 50, b:30},
                  bargap :0.15, barmode: 'stack'},"caption":"Annual burial count by product.","download-title":"Annual_burials"}}),_c('chart-card',{attrs:{"data":_vm.chartYearlyBurialsGroupsRel,"layout":{
                  yaxis: { tickformat:'.0%' },
                  xaxis: { tickformat:'.0f', dtick: 1 },
                  height: 270,
                  font: {size: 11},
                  margin: {t: 10, b:60},
                  bargap :0.05, barmode: 'stack'},"caption":"Proportion of annual burials by product.","download-title":"Annual_burial_proportion"}})],1)],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }